/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_JSXRuntime as JSXRuntime,
  rec_ListaInspecciones as ListaInspecciones,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_puedeInspecciones as puedeInspecciones,
} from "../../runtime/index.jsx";
export function Inspecciones() {
  let e = (0, ReactCompiler.c)(2);
  if (!puedeInspecciones()) {
    let t;
    return (
      e[0] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <AccesoDenegado />), (e[0] = t))
        : (t = e[0]),
      t
    );
  }
  let t;
  return (
    e[1] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((t = <ListaInspecciones />), (e[1] = t))
      : (t = e[1]),
    t
  );
}
